export const createQuestionGroupsService = (http, baseUrl) => {
  const buildURL = (path) => {
    return `${baseUrl}${path}`
  }

  const actions = {
    getGroupList () {
      const url = buildURL('/user/question/group')
      return http.get(url)
    },

    getGroup (groupId) {
      const url = buildURL(`/user/question/group/${groupId}`)
      return http.get(url)
    },

    createGroup (data) {
      const url = buildURL('/user/question/group')
      return http.post(url, data)
    },

    updateGroup (groupId, data) {
      const url = buildURL(`/user/question/group/${groupId}`)
      return http.put(url, data)
    },

    deleteGroup (groupId) {
      const url = buildURL(`/user/question/group/${groupId}`)
      return http.delete(url)
    }
  }

  return actions
}
